'use client'

import { Col, Icon, Row } from '@repo/ui/components'
import { ButtonLink } from '@repo/shared/components'
import { ClubTopBarLayout } from './club.topbar.layout'

export const ClubCTA = () => {
  const origin = 'layout'
  return (
    <Col
      className={`${origin === 'layout' ? 'sticky top-0' : ''} bg-neutral-surface-light sm:bg-transparent  px-xs pt-xs md:px-0  justify-between`}
    >
      <Row className='w-full justify-between'>
        <ButtonLink
          variant='transparent'
          size='md'
          color='neutral'
          href='/dashboard'
          startIcon={<Icon name='ArrowRightLine' size='md' />}
        ></ButtonLink>
      </Row>
      <ClubTopBarLayout />
    </Col>
  )
}
